var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-link no-disabler",attrs:{"title":"Hapus"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click', $event)}}},[_c('i',{staticClass:"fa fa-times"})])
}
var staticRenderFns = []

export { render, staticRenderFns }